exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.forum-photo[data-v-f5cd1512] {\n      width: 100%;\n      height: 150px;\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center;\n      background-color: #000000;\n}\n.overlay[data-v-f5cd1512] {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n}\n", ""]);

// exports
